import { ColDef } from 'ag-grid-community';
import { EXCEL_DATE_STYLE_ID } from 'src/constants/agGrid';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getStatusFromStartEndDates, getYYYYMMDDUTCStrFromTimestamp } from 'src/util/grid/cellGetter';
import {
    getPhoneToolLinkCellRenderer,
    getStatusCellRenderer,
    getTerritoryFlagRenderer
} from 'src/util/grid/cellRenderer';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

const bundlePricingBaseColDefs: ColDef[] = [
    {
        headerName: 'Territory',
        field: 'territory',
        filter: 'agSetColumnFilter',
        cellRenderer: getTerritoryFlagRenderer,
        valueFormatter: emptyCellFormatter,
        minWidth: 120
    },
    {
        headerName: 'Plan name',
        field: 'planName',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        width: 400,
        minWidth: 200
    },
    {
        headerName: 'Plan sub-attribute',
        field: 'planSubAttribute',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        minWidth: 180
    },
    {
        headerName: 'Currency',
        field: 'currency',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        minWidth: 120
    },
    {
        headerName: 'Price',
        field: 'price',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        minWidth: 120
    },
    {
        headerName: 'Start date',
        field: 'startDate',
        filter: 'agDateColumnFilter',
        comparator: dateComparator,
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 120
    },
    {
        headerName: 'End date',
        field: 'endDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'lessThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 120
    }
];

export const bundlePricingColDefs: ColDef[] = [
    ...bundlePricingBaseColDefs,
    {
        headerName: 'Last updated',
        field: 'lastUpdated',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 180
    },
    {
        headerName: 'Updated by',
        field: 'updatedBy',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        cellRenderer: getPhoneToolLinkCellRenderer,
        minWidth: 150
    },
    {
        headerName: 'Status',
        field: 'status',
        filter: 'agSetColumnFilter',
        valueGetter: getStatusFromStartEndDates,
        cellRenderer: getStatusCellRenderer,
        cellRendererParams: {
            displayText: true
        },
        minWidth: 120
    }
];

export const editBundlePricingColDefs: ColDef[] = [...bundlePricingBaseColDefs];

export const reviewBundlePricingColDefs: ColDef[] = [...bundlePricingBaseColDefs];
